/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class EFSRestoreDestination {
  /**
  * AWS region where the EFS file system will be restored.
  */
  'region': string;
  /**
  * Type of restore to perform. \'fullRestore\' restores the entire file system. \'itemLevelRestore\' restores specific files or directories specified in itemsToRestore. 
  */
  'restoreType'?: EFSRestoreDestinationRestoreTypeEnum;
  /**
  * File or directory paths to restore (for item-level restore). Paths are relative to the file system root and must start with \'/\'. Paths are case-sensitive; wildcard characters and regex are not supported. Only used when restoreType is \'itemLevelRestore\'. 
  */
  'itemsToRestore'?: Array<string>;
  /**
  * Whether to restore to a new file system or the existing source file system. When true, a new EFS file system is created (requires subnetIds). When false, items are restored to the source file system in a new timestamped directory. 
  */
  'restoreToNewFileSystem'?: boolean;
  /**
  * Name for the restored EFS file system (set as the Name tag). Only used when restoring to a new file system.
  */
  'fileSystemName'?: string;
  /**
  * Subnet IDs for the restored file system mount targets. Required when restoring to a new file system.
  */
  'subnetIds'?: Array<string>;
  /**
  * Security group IDs for mount targets. If not provided, the default security group will be used. Only used when restoring to a new file system.
  */
  'securityGroupIds'?: Array<string>;
  /**
  * KMS key ARN for encrypting the restored file system. If not provided, AWS managed encryption will be used. Only used when restoring to a new file system.
  */
  'encryptionKey'?: string;
  /**
  * Performance mode for the restored file system. If not provided, the original performance mode will be used. Only used when restoring to a new file system.
  */
  'performanceMode'?: EFSRestoreDestinationPerformanceModeEnum;
  /**
  * Throughput mode for the restored file system. If not provided, the original throughput mode will be used. Only used when restoring to a new file system.
  */
  'throughputMode'?: EFSRestoreDestinationThroughputModeEnum;
  /**
  * Provisioned throughput in MiB/s. Only applicable when throughputMode is \'provisioned\'.
  */
  'provisionedThroughputMibps'?: number;
  /**
  * Tags to apply to the restored file system. Only used when restoring to a new file system.
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreType",
      "baseName": "restoreType",
      "type": "EFSRestoreDestinationRestoreTypeEnum",
      "format": ""
    },
    {
      "name": "itemsToRestore",
      "baseName": "itemsToRestore",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "restoreToNewFileSystem",
      "baseName": "restoreToNewFileSystem",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "fileSystemName",
      "baseName": "fileSystemName",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetIds",
      "baseName": "subnetIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "securityGroupIds",
      "baseName": "securityGroupIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "encryptionKey",
      "baseName": "encryptionKey",
      "type": "string",
      "format": ""
    },
    {
      "name": "performanceMode",
      "baseName": "performanceMode",
      "type": "EFSRestoreDestinationPerformanceModeEnum",
      "format": ""
    },
    {
      "name": "throughputMode",
      "baseName": "throughputMode",
      "type": "EFSRestoreDestinationThroughputModeEnum",
      "format": ""
    },
    {
      "name": "provisionedThroughputMibps",
      "baseName": "provisionedThroughputMibps",
      "type": "number",
      "format": "double"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EFSRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum EFSRestoreDestinationRestoreTypeEnum {
  FullRestore = 'fullRestore',
  ItemLevelRestore = 'itemLevelRestore'
}
export enum EFSRestoreDestinationPerformanceModeEnum {
  GeneralPurpose = 'generalPurpose',
  MaxIo = 'maxIO'
}
export enum EFSRestoreDestinationThroughputModeEnum {
  Bursting = 'bursting',
  Provisioned = 'provisioned',
  Elastic = 'elastic'
}

